/**
 * Tools API - Equipment and tool management
 * @module api/tools
 */

import { apiRequest } from './core.js';

// =============================================================================
// TOOL API
// =============================================================================

/**
 * Tool API - Equipment/tool tracking
 */
export const toolAPI = {
  getAll: () => apiRequest('/tool'),
  getById: (id) => apiRequest(`/tool/${id}`),
  getByVehicle: (vehicleId) => apiRequest(`/tool?assigned_vehicle_id=${vehicleId}`),
  getByLocation: (locationId) => apiRequest(`/tool?assigned_location_id=${locationId}`),
  getUnassigned: () => apiRequest('/tool?assigned_to_type=unassigned'),
  create: (tool) => apiRequest('/tool', {
    method: 'POST',
    body: JSON.stringify(tool),
  }),
  update: (id, tool) => apiRequest(`/tool/${id}`, {
    method: 'PUT',
    body: JSON.stringify(tool),
  }),
  delete: (id) => apiRequest(`/tool/${id}`, {
    method: 'DELETE',
  }),
};

// =============================================================================
// TOOL SET API
// =============================================================================

/**
 * Tool Set API - Groups of tools
 */
export const toolSetAPI = {
  getAll: () => apiRequest('/tool_set'),
  getById: (id) => apiRequest(`/tool_set/${id}`),
  getByVehicle: (vehicleId) => apiRequest(`/tool_set?assigned_vehicle_id=${vehicleId}`),
  getByLocation: (locationId) => apiRequest(`/tool_set?assigned_location_id=${locationId}`),
  getUnassigned: () => apiRequest('/tool_set?assigned_to_type=unassigned'),
  create: (toolSet) => apiRequest('/tool_set', {
    method: 'POST',
    body: JSON.stringify(toolSet),
  }),
  update: (id, toolSet) => apiRequest(`/tool_set/${id}`, {
    method: 'PUT',
    body: JSON.stringify(toolSet),
  }),
  delete: (id) => apiRequest(`/tool_set/${id}`, {
    method: 'DELETE',
  }),
};

// =============================================================================
// TOOL SET ITEM API
// =============================================================================

/**
 * Tool Set Item API - Items within tool sets
 */
export const toolSetItemAPI = {
  getAll: () => apiRequest('/tool_set_item'),
  getById: (id) => apiRequest(`/tool_set_item/${id}`),
  getByToolSet: (toolSetId) => apiRequest(`/tool_set_item?tool_set_id=${toolSetId}`),
  getByTool: (toolId) => apiRequest(`/tool_set_item?tool_id=${toolId}`),
  create: (item) => apiRequest('/tool_set_item', {
    method: 'POST',
    body: JSON.stringify(item),
  }),
  update: (id, item) => apiRequest(`/tool_set_item/${id}`, {
    method: 'PUT',
    body: JSON.stringify(item),
  }),
  delete: (id) => apiRequest(`/tool_set_item/${id}`, {
    method: 'DELETE',
  }),
};

// =============================================================================
// TOOL DOCUMENT API
// =============================================================================

/**
 * Tool Document API - Documents attached to tools
 */
export const toolDocumentAPI = {
  getAll: () => apiRequest('/tool_document'),
  getById: (id) => apiRequest(`/tool_document/${id}`),
  getByTool: (toolId) => apiRequest(`/tool_document?tool_id=${toolId}`),
  getExpiringSoon: (days = 30) => apiRequest(`/tool_document?expiring_within_days=${days}`),
  create: (document) => apiRequest('/tool_document', {
    method: 'POST',
    body: JSON.stringify(document),
  }),
  update: (id, document) => apiRequest(`/tool_document/${id}`, {
    method: 'PUT',
    body: JSON.stringify(document),
  }),
  delete: (id) => apiRequest(`/tool_document/${id}`, {
    method: 'DELETE',
  }),
};
